import Stack from '@mui/material/Stack';
import { Getter } from "../../../services/ComService"
import { useEffect, useState } from 'react';
import { Status } from '../day/dayView';
import Spinner from '../../../components/Spinner/Spinner';
import ItemPersonDTO, { IItemPerson } from '../../DTO/ItemPersonDTO';
import { parseStringFromServer } from '../../../services/TextConverter';
import { Box, Card, CardContent, Link, Typography } from '@mui/material';
import ReportIcon from '@mui/icons-material/Report';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { DisplayDateFromString } from '../../../services/DateTime';

interface Conflict {
  id: number,
  name: string,
  eventId: number,
  eventName: string,
  eventDate: string,
}
interface PersonWithConflicts {
  person: {
    id: number,
    firstname: string,
    lastname: string,
    email: string,
  },
  Person?: ItemPersonDTO,
  conflicts: Conflict[],
}

function UniqueNames(conflicts: Conflict[]) {
  let names: string[] = []
  return conflicts.filter(c => {
    const testName = c.eventName + '->' + c.name
    if (names.includes(testName)) {
      return false
    }
    names.push(testName)
    return true
  }).sort((a, b) => {
    if (a.eventDate < b.eventDate) {
      return -1
    } else if (a.eventDate > b.eventDate) {
      return 1
    }
    if (a.eventName < b.eventName) {
      return -1
    } else if(a.eventName > b.eventName) {
      return 1
    }
    if (a.name < b.name) {
      return -1
    }
    return 1
  })
}

interface ICol {
  value: string,
  className: string,
  href?: string
}
interface IRow {
  cols: ICol[],
  className?: string
}

interface ITable {
  rows: IRow[],
  className?: string
}
function TableMaker(conflicts: Conflict[]): ITable {
  const uniqueNames = UniqueNames(conflicts)
  const sequenceNames: string[] = []
  uniqueNames.forEach(item => {
    if (!sequenceNames.includes(item.name)) {
      sequenceNames.push(item.name)
    }
  })
  const eventIds: number[] = []
  const events: { eventId: number, name: string }[] = []
  uniqueNames.forEach(item => {
    if (!eventIds.includes(item.eventId)) {
      eventIds.push(item.eventId)
      events.push({
        eventId: item.eventId,
        name: `${parseStringFromServer(item.eventName)} (${DisplayDateFromString(item.eventDate)})`
      })
    }
  })

  const table: ITable = {
    rows: [],
  }
  const row: IRow = {
    cols: []
  }
  row.cols.push({
    value: '',
    className: 'cross',
  })

  events.forEach(event => {
    row.cols.push({
      value: event.name,
      className: 'event w3-border w3-padding w3-white',
      href: `/view=spVeranstaltungsDetails/id=${event.eventId}`,
    })
  })
  table.rows.push(row)
  
  sequenceNames.forEach(sequence => {
    const cols: ICol[] = [
      {
        value: sequence,
        className: 'sequence w3-border w3-padding w3-white',
      }
    ]
    for (let i = 0; i < events.length; i++) {
      const event = events[i]
      const conflict = uniqueNames.find(c => c.name === sequence && c.eventId === event.eventId)
      cols.push({
        value: conflict ? 'X' : '',
        className: `w3-border w3-padding ${conflict ? 'w3-red w3-text-white w3-text-align-center' : 'w3-white'}`,
      })
    }
    const row: IRow = {
      cols: cols
    }
    
    table.rows.push(row)
  })
  return table
}

export default function ModulePersonConflicts({
  id,
}: {
  id: number,
}) {
  const [status, setStatus] = useState(Status.loading)
  const [conflicts, setConflicts] = useState<PersonWithConflicts[]>([])
  const renewConflicts = async () => {
    setStatus(Status.loading)
    Getter('EventModulePersonConflict/' + id).then((data) => {
      console.log('EventModulePersonConflict', data)
      setConflicts(data.personConflicts.map((pc: PersonWithConflicts) => {
        return {
          ...pc,
          conflicts: pc.conflicts.filter(pc => pc.name),
          Person: new ItemPersonDTO(pc.person as IItemPerson),
        }
      }).filter((c: PersonWithConflicts) => c.conflicts.length > 0))
      setStatus(Status.standard)
    })
  }
  useEffect(() => {
    renewConflicts()
  }, [id])
  const headline = <h2>Sequenz / Person Konflikte</h2>
  if (status === Status.loading) {
    return <>
      {headline}
      <Spinner />
    </>
  }
  return <Stack
    spacing={2}
    sx={{
      backgroundColor: '#fff',
      padding: 4,
    }}
  >
    {headline}

    {
      conflicts.length === 0 &&
      <Box>
        <p><b><CheckCircleIcon /> Keine Konflikte gefunden</b></p>
      </Box>
    }
    {
      conflicts.map((conflict: PersonWithConflicts) => {
        return <Card
          key={conflict.person.id}
          sx={{
            backgroundColor: 'grey.100',
          }}
        >
          <CardContent>
            <Typography variant="h5" component="div" sx={{
              marginBottom: 2,
            }}>
              <Link
                href={`/view=spPersonEdit/id=${conflict.Person!.id}`}>
                <ReportIcon /> {conflict.Person!.getDisplayName()}
              </Link>
            </Typography>
            <Stack
              spacing={2}
            >
              {
                /*
                UniqueNames(conflict.conflicts).map((c: Conflict) => {
                  return <Stack
                    key={c.id}
                    direction={'row'}
                    spacing={2}
                    sx={{
                      
                    }}
                  >
                    <Box>
                      <Link
                        href={`/view=spVeranstaltungsDetails/id=${c.eventId}`}
                      >
                        &rarr; {parseStringFromServer(c.eventName)} ({DisplayDateFromString(c.eventDate)})
                      </Link>
                    </Box>
                    <Box>{parseStringFromServer(c.name)}</Box>
                  </Stack>
                })
                */
              }
              <hr />
              <table
                style={{
                  borderCollapse: 'collapse',
                }}
              >
                <tbody>
                  {
                    TableMaker(conflict.conflicts).rows.map((r: IRow) => {
                      return <tr>
                        {
                          r.cols.map((c: ICol) => {
                            return <td className={c.className}>
                              {c.href ? <Link href={c.href}>{c.value}</Link> : c.value}
                            </td>
                          })
                        }
                      </tr>
                    })
                  }
                </tbody>
              </table>
            </Stack>
          </CardContent>
        </Card>
      })
    }
  </Stack>
}